import React from "react"

import Field_GraphTickLabelView from "../../../proto/render/graph-tick-label"
import UI5Rating from "../../../../gd-ui/rating/rating"
import FieldRating from "../rating"

const LABEL_SHOW_THRESHOLD = 100

type Props = {
    field       : FieldRating
    model       : any

    params?     : any           // some special parameters (like 'availableWidth' for charts)
}

const debug = false
// const debug = "FieldRating_GraphTickLabelView"

export default function FieldRating_GraphTickLabelView(props: Props) {

    const value = props.field.groupValue(_.get(props.model, props.field.fieldId, null))

    debug && console.log(debug, 'render', value, props)

    let showLabel = props.params.availableWidth < LABEL_SHOW_THRESHOLD

    const isSet = !_.isNil(value)

    return (
        <Field_GraphTickLabelView {...props}>
            {!showLabel &&
                <UI5Rating scale={props.field.scale} value={value} showEmpty={true}/>}

            {showLabel &&
                <React.Fragment>
                    {isSet &&
                        <React.Fragment>
                            <div className="ui5-txt-default-small txt-truncate m-r-5">{value}</div>
                            <UI5Rating scale={1} value={1}/>
                        </React.Fragment>}

                    {!isSet &&
                        <UI5Rating scale={1} value={0} showEmpty={true}/>}
                </React.Fragment>}
        </Field_GraphTickLabelView>
    )
}